import React from "react";
import {IMAGES, KButton, KBUTTON_SIZE, KBUTTON_VARIANT, KSpace} from "@kopjra/uikit";
import {Translate} from "react-redux-i18n";
import {Col, Row} from "react-bootstrap";
import {Routes} from "../../utils/router";

export interface Props {
    text?: string | JSX.Element;
}

export const BuyCTA: React.FC<Props> = ({text}) => {
    return (
        <>
            <KSpace spaces={3}/>
            <img src={IMAGES["web-trust"].still.large.dark} height={165} alt={"Web trust"}/>
            <KSpace/>
            <h4>{text ? text : <Translate value="user.apiKeys.notAllowed"/>}</h4>
            <KSpace spaces={2}/>
            <Row>
                <Col md={4} lg={3}>
                    <KButton
                        text={<Translate value="user.buy"/>}
                        variant={KBUTTON_VARIANT.primary}
                        size={KBUTTON_SIZE.nm}
                        onClick={() => window.open(Routes.STORE, "_blank")}
                        fill={true}
                    />
                </Col>
            </Row>
            {/*<KSpace spaces={2}/>*/}
            {/*<h4><a className="link" href={`mailto:info@kopjra.com?subject=${I18n.t("home.contactSubject")}&body=${I18n.t("home.contactBody")}`} target="_blank" rel="noopener noreferrer"><Translate value="home.contactus"/></a></h4>*/}
        </>
    )
}
